(() => {
  function init(options) {
    if (options.dataset.initialized) return;
    const form = options.closest('form');
    if (!form) return;
    options.dataset.initialized = 'true';
    const variants = JSON.parse(options.querySelector('[data-mbm-variants]').textContent);
    const optionNames = JSON.parse(options.querySelector('[data-mbm-options]').textContent);
    const colorIndex = optionNames.findIndex((name) => /^(blanket )?(color|colour)$/i.test(name.trim()));
    const placementIndex = optionNames.findIndex((name) => /^(print |logo |design )?placement$/i.test(name.trim()));
    const error = options.querySelector('[data-mbm-error]');
    const idInput = form.querySelector('input[name="id"]');
    const submit = form.querySelector('button[type="submit"]');
    const toggle = options.querySelector('[data-mbm-last-name-toggle]');
    const nameField = options.querySelector('[data-mbm-last-name-field]');
    const nameInput = options.querySelector('[data-mbm-last-name]');
    const total = options.querySelector('[data-mbm-total]');
    const section = options.closest('.shopify-section');
    const priceElement = section?.querySelector('[id^="price-"] .price-item--regular');
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: window.Shopify?.currency?.active || 'USD', maximumFractionDigits: 2
    });
    let current = null;
    let busy = false;

    function showError(message) {
      error.textContent = message || '';
      error.hidden = !message;
    }
    function selected(name) { return options.querySelector(`input[name="${name}"]:checked`)?.value; }
    function normalized(value) { return String(value || '').trim().toLowerCase().replace(/grey/g, 'gray').replace(/\s+/g, ' '); }
    function samePlacement(value, requested) {
      const actual = normalized(value);
      return actual === normalized(requested) || (requested === 'Large centered print' && /large|center/.test(actual)) ||
        (requested === 'Small corner print' && /small|corner|pocket/.test(actual));
    }
    function refresh() {
      const color = selected(`mbm-blanket-color-${options.dataset.sectionId}`);
      const placement = selected('properties[Print placement]');
      const expectedPrice = Number(placement === 'Large centered print' ? options.dataset.largePrice : options.dataset.smallPrice);
      const colorVariants = colorIndex < 0 ? [] : variants.filter((variant) => normalized(variant.options[colorIndex]) === normalized(color));
      const placementVariants = placementIndex < 0 ? [] : colorVariants.filter((variant) => samePlacement(variant.options[placementIndex], placement));
      current = placementVariants.find((variant) => variant.price === expectedPrice) || placementVariants[0] || null;
      // Some stores call the option "front pocket" or "center logo"; price uniquely identifies it when wording differs.
      if (!current && placementIndex >= 0) {
        const priceVariants = colorVariants.filter((variant) => variant.price === expectedPrice);
        if (priceVariants.length === 1) current = priceVariants[0];
      }
      const valid = colorIndex >= 0 && placementIndex >= 0 && current && current.available && current.price === expectedPrice;
      idInput.value = valid ? current.id : '';
      idInput.disabled = !valid;
      submit.disabled = busy || !valid;
      const message = colorIndex < 0 || placementIndex < 0
        ? 'Blanket setup needed: add Color and Print placement options to this product.'
        : !current ? `No ${color || 'selected color'} ${placement === 'Large centered print' ? 'large centered' : 'small pocket'} variant at ${formatter.format(expectedPrice / 100)} is available for this product.`
        : !current.available ? 'This combination is sold out.'
        : current.price !== expectedPrice ? 'Blanket pricing needs to be updated before checkout.' : '';
      showError(message);
      if (!valid) return;
      const formatted = formatter.format(current.price / 100);
      if (priceElement) priceElement.textContent = formatted;
      total.textContent = formatter.format((current.price + (toggle?.checked ? 500 : 0)) / 100);
      if (current.featured_media?.id) {
        const gallery = section?.querySelector('media-gallery');
        gallery?.setActiveMedia?.(`${options.dataset.sectionId}-${current.featured_media.id}`, true);
      }
    }
    options.addEventListener('change', (event) => {
      if (event.target.name === `mbm-blanket-color-${options.dataset.sectionId}`) {
        const pictured = options.dataset.blanketType === 'nylon' ? {} : { 'Ash Gray': 'Barrington B', 'Sport Gray': 'Horseshoe B', Black: 'Barrington (Shown)', Red: 'Bronco' };
        const currentDesign = selected('properties[Design]');
        if (['Bronco', 'Barrington (Shown)', 'Horseshoe B', 'Barrington B'].includes(currentDesign)) {
          const suggested = pictured[event.target.value];
          const radio = [...options.querySelectorAll('input[name="properties[Design]"]')].find((input) => input.value === suggested);
          if (radio) radio.checked = true;
        }
      }
      if (event.target === toggle) {
        nameField.hidden = !toggle.checked;
        nameInput.disabled = !toggle.checked;
        nameInput.required = toggle.checked;
        if (!toggle.checked) nameInput.value = '';
      }
      refresh();
    });
    refresh();

    // Intercept Dawn's form submit so the priced name add-on and blanket are added in one request.
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      refresh();
      if (!current || !idInput.value || !form.reportValidity()) return;
      const addon = options.dataset.addonVariant;
      if (toggle?.checked && !addon) {
        showError('Last name pricing needs to be configured before checkout.');
        return;
      }
      const properties = Object.fromEntries([...new FormData(form).entries()]
        .filter(([key]) => key.startsWith('properties['))
        .map(([key, value]) => [key.slice(11, -1), value]));
      if (!properties.Design) { showError('Please choose a design.'); return; }
      if (!toggle?.checked) delete properties['Last name'];
      else properties['Last name placement'] = 'One corner of the blanket';
      const quantity = Math.max(1, Number(new FormData(form).get('quantity')) || 1);
      const items = [{ id: Number(current.id), quantity, properties }];
      if (toggle?.checked) items.push({ id: Number(addon), quantity, properties: {
        'For blanket': properties['Last name'], 'Blanket color': selected(`mbm-blanket-color-${options.dataset.sectionId}`),
        'Blanket design': properties.Design, 'Last name placement': 'One corner of the blanket'
      }});
      busy = true;
      submit.disabled = true;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', { method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Could not add this blanket to the cart.');
        location.assign(root + 'cart');
      } catch (failure) {
        showError(failure.message);
        busy = false;
        submit.disabled = false;
      }
    }, true);
  }
  document.querySelectorAll('[data-mbm-blanket]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-mbm-blanket]').forEach(init));
})();
